import { useNavigate } from 'react-router-dom';

export function Java() {
  const navigate = useNavigate();

  // Function to handle navigation
  const navigateTo = (path) => {
    navigate(path);
  };

  // Data for platforms
  const platforms = [
    { name: 'YouTube', path: '/Backend_Java_Yt', img: 'https://example.com/youtube-logo.jpg' },
    { name: 'Coursera', path: '/Backend_Java_Coursera', img: 'https://example.com/coursera-logo.jpg' },
    { name: 'Udemy', path: '/Backend_Java_Udemy', img: 'https://example.com/udemy-logo.jpg' },
    { name: 'GeeksForGeeks', path: '/Backend_Java_Gfg', img: 'https://example.com/gfg-logo.jpg' },
    { name: 'Practice Questions', path: '/Backend_Java_Codplat', img: 'https://example.com/practice-logo.jpg' },
  ];

  return (
    <div>
      <h1>Links are below</h1>
      <p>
        Explore these platforms for <strong>Java</strong> learning. They are for <strong>educational purposes</strong> to
        help you gain knowledge effectively.
      </p>

      <h3>Recommended Platforms</h3>

      <div>
        {platforms.map((platform) => (

          <div key={platform.name} style={{ margin: '20px', textAlign: 'center' }}>

            <img
              src={platform.img}
              alt={`${platform.name} logo`}
              style={{ width: '90px', height: '90px' }}
            />

            <h5>{platform.name}</h5>

            <button onClick={() => navigateTo(platform.path)}>Click Me</button>

          </div>

        ))}
        
      </div>
    </div>
  );
}

export default Java;
